import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const DoughnutChart = ({ orderPrize, costPrize, fontColor }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const balance = orderPrize - costPrize;
    const total = Math.abs(orderPrize); // Use absolute value for total
    const balancePercentage = ((Math.abs(balance) / total) * 100).toFixed(1);
    const costPercentage = ((Math.abs(costPrize) / total) * 100).toFixed(1);

    const isBalanceShown = balance > 0;

    const data = {
      labels: isBalanceShown ? ["Balance", "Cost"] : ["Cost"],
      datasets: [
        {
          data: isBalanceShown
            ? [Math.abs(balance), Math.abs(costPrize)]
            : [Math.abs(costPrize)], // Exclude balance if it's negative or zero
          backgroundColor: isBalanceShown
            ? ["#c2f747", "#F9CAF9"]
            : ["#F9CAF9"], // Green for balance, pink for cost
          borderWidth: 2,
          borderColor: "#000", // Black border for segments
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false, // Hide the default legend
        },
        tooltip: {
          callbacks: {
            label: (tooltipItem) => {
              return `${tooltipItem.label}: ${tooltipItem.raw}%`;
            },
          },
        },
      },
      cutout: "70%", // Creates the doughnut effect
    };

    const config = {
      type: "doughnut",
      data,
      options,
      plugins: [
        {
          id: "centerText",
          beforeDraw: (chart) => {
            const { ctx, chartArea } = chart;
            const { width, height } = chartArea;
            const centerX = width / 2;
            const centerY = height / 2;

            const centerTextColor = balance > costPrize ? "#c2f747" : "#F9CAF9";

            ctx.save();
            ctx.font = "bold 24px Helvetica, Verdana";
            ctx.fillStyle = centerTextColor;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";

            const percentageText = isBalanceShown
              ? `${balancePercentage}%`
              : `${costPercentage}%`;

            ctx.fillText(percentageText, centerX, centerY);
            ctx.restore();
          },
        },
      ],
    };

    const canvas = canvasRef.current;
    const chartInstance = new Chart(canvas, config);

    return () => {
      chartInstance.destroy(); // Cleanup chart instance on component unmount
    };
  }, [orderPrize, costPrize, fontColor]);

  return <canvas ref={canvasRef} width="200" height="200"></canvas>;
};

export default DoughnutChart;
